import * as React from "react"

function SvgComponent(props) {
  return (
    <svg viewBox="0 0 15 15" {...props}>
      <title>{"Artboard"}</title>
      <path
        d="M14.57 12.54L8.39.63c-.34-.67-1.43-.67-1.78 0L.43 12.54c-.16.31-.15.68.03.98.18.3.51.48.86.48h12.36c.35 0 .67-.18.85-.48.18-.3.2-.67.04-.98zM7 5c0-.28.22-.5.5-.5s.5.22.5.5v3.5c0 .28-.22.5-.5.5S7 8.78 7 8.5V5zm.5 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        fill="#FFAF36"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default SvgComponent
